exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.w-50-mobile[data-v-4476999b]{width:50%!important}.w-100-mobile[data-v-4476999b]{width:100%!important}}.label[data-v-4476999b]{font-weight:400;font-size:.9rem}input[data-v-4476999b]:invalid{background-color:#ffbebe}figure img[data-v-4476999b],img[data-v-4476999b]{max-height:none}", ""]);

// exports
